import HttpRequest from '@/util/HttpRequest'

export default {
  async FILE_UPLOAD ({commit}, params) {

    const formData = new FormData()
    formData.append('file_data', params)

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/file', formData)
        .then(response => {
          commit('FILE_UPLOAD', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async FILE_DOWNLOAD ({commit}, params) {
    const option = {
      params: {
        hashedName: params.hashedName
      },
      responseType: 'blob'
    }

    return new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/file', option)
        .then(response => {
          resolve(response)
        }).catch(err => reject(err))
    })
  }
}
